export default function NoiseOverlay() {
  return (
    <div 
      className="noise-overlay"
      aria-hidden="true"
      data-testid="noise-overlay"
    />
  );
}
